<template>
  <div class="view-setting">
    <div class="body-row" :class="from">
      <div class="body-item item-left" v-ps>
        <div class="panel">
          <div class="panel-title font-main">基本信息</div>
          <div class="panel-content">
            <div class="panel-content-row">
              <div class="font-main">视图名称</div>
              <el-input
                v-if="from === 'fronted'"
                :disabled="disabled"
                v-model="view.name"
                size="medium"
              ></el-input>
              <el-input
                v-if="from === 'backend'"
                :disabled="view.name == '全部'"
                :value="view.name"
                @input="changeViewName"
              ></el-input>
            </div>
            <div class="panel-content-row">
              <div class="font-main">视图类型</div>
              <el-select
                v-model="view.type"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
                @change="setViewInfo"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div v-if="view.type === 'TREE'" class="panel-content-row">
              <div class="font-main">关联字段</div>
              <el-select
                v-model="view.treeKey"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in refOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div v-if="view.type === 'BOARD'" class="panel-content-row">
              <div class="font-main">分组字段</div>
              <el-select
                v-model="view.boardKey"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in groupControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
            <div v-if="view.type === 'GANTT'" class="panel-content-row">
              <div class="font-main">开始日期</div>
              <el-select
                v-model="view.ganttConfig.startCid"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
                @change="getTimeType"
                clearable
              >
                <el-option
                  v-for="item in timeControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
            <div v-if="view.type === 'GANTT'" class="panel-content-row">
              <div class="font-main">结束日期</div>
              <el-select
                v-model="view.ganttConfig.endCid"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
                @change="getTimeType"
                clearable
              >
                <el-option
                  v-for="item in timeControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
            <div class="panel-content-row">
              <div class="font-main">视图描述</div>
              <el-input
                :disabled="disabled"
                v-model="view.desc"
                size="medium"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="panel" v-if="!(from === 'backend' && view.name === '全部')">
          <div class="panel-title font-main">数据范围</div>
          <div class="panel-content">
            <div class="panel-content-row">
              <div class="font-main">筛选</div>
              <condition-list
                :disabled="disabled"
                :conditions="view.filters"
                :search-sheet="{ sheetId: view.sheetId, controls: controls }"
              ></condition-list>
            </div>
          </div>
        </div>
      </div>
      <div v-ps class="body-item item-right">
        <div class="panel">
          <div class="panel-title font-main">显示设置</div>
          <div class="panel-content">
            <div class="panel-content-row" v-if="['BOARD', 'ALBUM', 'GANTT'].includes(view.type)">
              <div class="font-main">标题字段</div>
              <el-select
                v-model="view.titleCid"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
                @change="setShowField"
                clearable
              >
                <el-option
                  v-for="item in titleControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
            <div class="panel-content-row">
              <div class="font-main">显示字段</div>
              <hide-dropdown
                :view="view"
                :canHideFieldsMap="canHideFieldsMap"
                :disabled="disabled"
                from="dialog"
              ></hide-dropdown>
            </div>
            <div class="panel-content-row app-setting">
              <span class="font-main">移动端显示前</span>
              <el-select
                v-model="view.displayNum"
                :disabled="disabled"
                class="selector"
                placeholder="请选择"
              >
                <el-option v-for="item in 10" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span class="font-main">个</span>
            </div>
            <div class="panel-content-row" v-if="['BOARD', 'ALBUM'].includes(view.type)">
              <div class="font-main">封面</div>
              <el-select
                v-model="view.coverCid"
                :disabled="disabled"
                clearable
                class="selector"
                placeholder="请选择"
                @change="setShowField"
              >
                <el-option
                  v-for="item in coverControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
            <template v-if="view.type === 'GANTT'">
              <div class="panel-content-row">
                <div class="font-main">分组字段</div>
                <el-select
                  v-model="view.ganttConfig.groupField"
                  :disabled="disabled"
                  class="selector"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in groupControls"
                    :key="item._cid"
                    :label="item.name"
                    :value="item._cid"
                  ></el-option>
                </el-select>
              </div>
              <div class="panel-content-row">
                <div class="font-main">里程碑</div>
                <el-select
                  v-model="view.ganttConfig.milestone"
                  :disabled="disabled"
                  class="selector"
                  clearable
                  placeholder="请选择"
                  @change="setShowField"
                >
                  <el-option
                    v-for="item in checkControls"
                    :key="item._cid"
                    :label="item.name"
                    :value="item._cid"
                  ></el-option>
                </el-select>
              </div>
            </template>
            <div class="panel-content-row">
              <div class="font-main">排序</div>
              <sort-list
                :disabled="disabled"
                :sheet-list="controls"
                :sorts="view.sorts"
              ></sort-list>
            </div>
            <div class="panel-content-row" v-if="!['BOARD', 'ALBUM', 'GANTT'].includes(view.type)">
              <div class="font-main">行高</div>
              <el-radio-group
                :disabled="disabled"
                class="line-height"
                v-model="view.lineHeightLevel"
              >
                <el-radio-button :label="1">紧凑</el-radio-button>
                <el-radio-button :label="2">舒适</el-radio-button>
                <el-radio-button :label="3">宽敞</el-radio-button>
              </el-radio-group>
            </div>
            <div class="panel-content-row">
              <div class="font-main">设置</div>
              <el-checkbox :disabled="disabled" v-model="view.showTotalCount" class="checkbox">
                显示汇总
              </el-checkbox>
              <el-checkbox
                v-if="['BOARD', 'ALBUM', 'LIST'].includes(view.type)"
                :disabled="disabled"
                v-model="view.showButton"
                class="checkbox"
              >
                显示按钮
              </el-checkbox>
            </div>
          </div>
        </div>
        <div class="panel" v-if="view.type && view.type !== 'GANTT'">
          <div class="panel-title font-main">快捷设置</div>
          <div class="panel-content">
            <div class="panel-content-row" v-if="['LIST', 'ALBUM'].includes(view.type)">
              <div class="font-main">分类导航</div>
              <div class="category">
                <div
                  v-for="(item, index) in view.navCids"
                  :key="index"
                  style="display: flex;align-items: center"
                >
                  <div class="item">
                    <span>{{ controlMap[item] ? controlMap[item].name : "组件不存在" }}</span>
                    <i
                      class="el-icon-circle-close close"
                      v-if="!disabled"
                      @click="dealCategory(index)"
                    ></i>
                  </div>
                  <i
                    class="el-icon-arrow-right"
                    v-if="index < view.navCids.length - 1"
                    style="margin: 0 6px"
                  ></i>
                </div>
                <template v-if="selectVisible">
                  <i
                    class="el-icon-arrow-right"
                    v-if="view.navCids.length"
                    style="margin: 0 6px"
                  ></i>
                  <el-select
                    :value="selectVisible ? '' : newCategory"
                    placeholder="请选择"
                    filterable
                    @change="addToList"
                    :disabled="disabled"
                  >
                    <el-option
                      v-for="item in cateControls"
                      :key="item._cid"
                      :label="item.name"
                      :value="item._cid"
                    ></el-option>
                  </el-select>
                </template>
                <span style="margin-left: 10px; margin-bottom: 6px;" @click="getNewCategory">
                  <svg-icon
                    v-if="!selectVisible && !disabled"
                    icon-class="workflow_script_add-script"
                    class="pointer"
                    style="font-size: 20px"
                  ></svg-icon>
                </span>
              </div>
            </div>
            <div class="panel-content-row">
              <div class="font-main">快速筛选</div>
              <el-select
                v-model="view.filterCids"
                :disabled="disabled"
                filterable
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in quickControls"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import { typeOptions } from "./static"
import SortList from "@/components/UIComponents/SortList"
import HideDropdown from "@/components/UIComponents/HideDropdown"
import { verifyCondition, transFieldControl } from "@/utils/sheet"

export default {
  name: "ViewSetting",
  components: {
    ConditionList,
    SortList,
    HideDropdown
  },
  props: {
    view: Object,
    controls: Array,
    from: String
  },
  data() {
    return {
      typeOptions,
      newCategory: "",
      selectVisible: true,
      timeType: ""
    }
  },
  computed: {
    allControls() {
      return this.controls
        ?.concat([
          { name: "创建人", _cid: "cid", _type: "staff" },
          { name: "负责人", _cid: "oid", _type: "staff" },
          { name: "最后修改人", _cid: "upid", _type: "staff" },
          { name: "创建时间", _cid: "cat", _type: "time" },
          { name: "最后修改时间", _cid: "uat", _type: "time" }
        ])
        .map(control => transFieldControl(control))
    },
    // 可隐藏的字段，只能隐藏非主键
    canHideFields() {
      let controls = this.controls?.filter(c => c._type !== "remark" && !c.main) || []
      return controls.map(control => {
        return {
          label: control.name,
          value: control._cid
        }
      })
    },
    canHideFieldsMap() {
      let result = {}
      if (this.controls) {
        let titleControl = this.controls.find(control => control.main === true)
        result[titleControl._cid] = {
          label: titleControl.name,
          value: titleControl._cid,
          type: titleControl._type,
          title: true
        }
        this.controls
          .concat([
            { name: "创建人", _cid: "cid", _type: "staff" },
            { name: "负责人", _cid: "oid", _type: "staff" },
            { name: "最后修改人", _cid: "upid", _type: "staff" },
            { name: "创建时间", _cid: "cat", _type: "time" },
            { name: "最后修改时间", _cid: "uat", _type: "time" }
          ])
          .forEach(i => {
            if (i._type !== "remark" && !i.main) {
              result[i._cid] = {
                label: i.name,
                value: i._cid,
                type: i._type,
                title: false
              }
            }
          })
      }
      return result
    },
    // 如果是公共应用,则不可编辑
    disabled() {
      return this.from === "fronted" && this.view.id && this.view.open
    },
    refOptions() {
      let controls = this.controls.filter(x => x._type == "ref" && !x.oneFlag && x.twoWay)
      return controls.map(control => {
        return {
          label: "[关联表]" + control.name,
          value: control._cid
        }
      })
    },
    groupControls() {
      return this.allControls?.filter(
        control =>
          ["option", "rate"].includes(control._type) &&
          (control._type === "option" ? control.oneFlag : true)
      )
    },
    checkControls() {
      return this.allControls?.filter(control => control._type === "check")
    },
    titleControls() {
      return this.allControls
    },
    coverControls() {
      return this.allControls?.filter(control => control._type === "file")
    },
    cateControls() {
      return this.allControls?.filter(
        control =>
          ["option", "text", "company", "department", "staff", "rate", "check"].includes(
            control._type
          ) && !this.view.navCids.includes(control._cid)
      )
    },
    timeControls() {
      return this.allControls?.filter(
        control =>
          control._type === "time" && (this.timeType ? control.timeType === this.timeType : true)
      )
    },
    controlMap() {
      let result = {}
      this.allControls.forEach(control => {
        result[control._cid] = control
      })
      return result
    },
    quickControls() {
      let controls = (this.controls || []).concat([
        { name: "创建人", _cid: "cid", _type: "staff" },
        { name: "负责人", _cid: "oid", _type: "staff" },
        { name: "参与人", _cid: "pts", _type: "staff" },
        { name: "最后修改人", _cid: "upid", _type: "staff" },
        { name: "创建时间", _cid: "cat", _type: "time", timeType: "年月日时分秒" },
        { name: "最后修改时间", _cid: "uat", _type: "time", timeType: "年月日时分秒" }
      ])
      return controls.filter(
        control => !["location", "file", "code", "remark", "sign", "chart"].includes(control._type)
      )
    }
  },
  methods: {
    getGanttConfigTimeResult() {
      let result = true
      this.timeType = null
      if (this.view.ganttConfig?.startCid && this.view.ganttConfig?.endCid) {
        let startControl = this.allControls.find(
          control => control._cid === this.view.ganttConfig.startCid
        )
        let endControl = this.allControls.find(
          control => control._cid === this.view.ganttConfig.endCid
        )
        result = startControl.timeType === endControl.timeType
        if (result) this.timeType = startControl.timeType
      }
      if (!result) {
        this.$message.error("开始时间与结束时间设置有误，请重新设置")
        this.view.ganttConfig.startCid = null
        this.view.ganttConfig.endCid = null
      }
    },
    initSelectVisible() {
      this.getGanttConfigTimeResult()
      this.selectVisible = !this.view.navCids.length
    },
    getNewCategory() {
      this.newCategory = ""
      this.selectVisible = true
    },
    addToList(val) {
      if (val) {
        this.view.navCids.push(val)
        this.selectVisible = false
      }
    },
    dealCategory(index) {
      this.view.navCids.splice(index, 1)
      if (this.view.navCids.length === 0) {
        this.selectVisible = true
        this.newCategory = ""
      }
    },
    getTimeType(val) {
      if (!this.view.ganttConfig?.startCid && !this.view.ganttConfig?.endCid) {
        this.timeType = null
      }
      if (val) {
        let control = this.timeControls.find(control => control._cid === val)
        this.timeType = control.timeType
      }
    },
    setShowField(val) {
      this.view.hides = this.view.hides.filter(x => x != val)
    },
    changeViewName(viewName) {
      if (viewName === "全部") {
        this.$message.warning("视图名称不能为：全部")
        return
      }
      this.view.name = viewName
    },
    setViewInfo(viewType) {
      this.$set(this.view, "boardKey", null)
      this.$set(this.view, "ganttConfig", {})
      this.view.navCids = []
      this.view.filterCids = []
      this.view.treeKey = null
      this.newCategory = ""
      this.selectVisible = true
      if (["BOARD", "ALBUM", "GANTT"].includes(viewType)) {
        let mainControl = this.controls.find(control => control.main)
        this.$set(this.view, "titleCid", mainControl._cid)
      } else {
        this.$set(this.view, "titleCid", null)
      }
      if (viewType === "ALBUM") {
        this.view.hides = this.allControls.slice(3).map(control => control._cid)
      } else {
        this.view.hides = []
      }
    },
    beforeSubmit() {
      let resultInfo = { result: true, msg: "" }
      switch (this.view.type) {
        case "TREE": {
          if (!this.view.treeKey) {
            resultInfo = { result: false, msg: "未选择关联字段" }
          }
          break
        }
        case "BOARD": {
          if (!this.view.boardKey) {
            resultInfo = { result: false, msg: "未选择分组字段" }
            break
          }
          if (!this.view.titleCid) {
            resultInfo = { result: false, msg: "未选择标题字段" }
          }
          break
        }
        case "GANTT": {
          if (!this.view.ganttConfig.startCid) {
            resultInfo = { result: false, msg: "未选择开始时间" }
            break
          }
          if (!this.view.ganttConfig.endCid) {
            resultInfo = { result: false, msg: "未选择结束时间" }
            break
          }
          if (!this.view.titleCid) {
            resultInfo = { result: false, msg: "未选择标题字段" }
          }
          break
        }
        case "ALBUM": {
          if (!this.view.titleCid) {
            resultInfo = { result: false, msg: "未选择标题字段" }
          }
          break
        }
      }
      if (resultInfo.result) resultInfo = verifyCondition("submit", this.view.filters)
      return resultInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.view-setting {
  .fronted {
    height: 450px;
  }
  .backend {
    height: 100%;
  }
  .body-row {
    flex: auto;
    display: flex;
    .item-left {
      border-right: 1px solid #eee;
    }
    .body-item {
      flex: 1;
      padding: 0 24px;
      .panel {
        padding: 14px 0;
        .panel-title {
          font-weight: 600;
        }
        .panel-content {
          .panel-content-row {
            margin-top: 14px;
            .font-main {
              margin-bottom: 6px;
            }
            .el-select {
              width: 100%;
            }
            .category {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              .item {
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                padding: 5px 10px;
                color: #606266;
                width: 120px;
                display: flex;
                justify-content: center;
                margin-bottom: 6px;
                position: relative;
                font-size: 14px;
                &:hover {
                  .close {
                    visibility: visible;
                    cursor: pointer;
                  }
                }
                .close {
                  visibility: hidden;
                  position: absolute;
                  right: 6px;
                  top: 8px;
                  color: #dcdfe6;
                }
              }
              .el-select {
                width: 142px;
              }
            }
            ::v-deep {
              .el-textarea__inner {
                resize: none;
              }
            }
          }
          .app-setting {
            display: flex;
            align-items: center;
            .el-select {
              width: 30%;
              margin: 0 6px;
            }
          }
        }
      }
    }
  }
  .hide-dropdown {
    color: #606266;
    ::v-deep {
      .el-popover__reference-wrapper {
        .selector {
          margin-top: 0;
          font-size: 14px;
        }
      }
    }
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #303133;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #303133;
  }
  ::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #303133;
  }
  ::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #303133;
  }
  ::v-deep .el-radio-button__orig-radio:disabled:checked + .el-radio-button__inner {
    background-color: #f5f7fa;
  }
  ::v-deep .el-radio-button__inner {
    padding: 8.2px 17.5px;
  }
}
</style>
